<template>

    <div class="product-notification">
        <div class="red-circle">!</div>
        Enter your email to be notified when this product is back in-stock.
        <div v-if="notification.show">
            <div>
                <input type="text"
                       v-model.trim="email"
                       placeholder="e-mail"
                       @keyup.enter="saveNotification()"
                >
                <div class="btn btn-notification"
                     @click="saveNotification()">
                    notify me
                </div>
            </div>
            <div class="error" v-if="error">
                Not a valid email address
            </div>
        </div>
        <div class="success" v-else>
            THANKS! WE'LL BE IN TOUCH
        </div>
    </div>

</template>

<script>

    import ApiNotification from '@/api/Notification'

    export default {
        name: 'notification',
        props: {
            notificationId: {
                type: String,
                required: true
            },
            notificationType: {
                type: String,
                required: true
            },
            initialNotification: {
                type: Object,
                default: {show: true}
            }
        },
        data: function () {
            return {
                email: '',
                error: false,
                notification: this.initialNotification
            }
        },
        methods: {
            saveNotification() {
                let regex = /[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}/igm
                if (this.email == '' || !regex.test(this.email)){
                    this.error = true
                } else {
                    this.error = false
                    let payload = {
                        notifiable_id: this.notificationId,
                        notifiable_type: this.notificationType,
                        email: this.email
                    }
                    ApiNotification.addNotification(payload)
                        .then(response => {
                            this.notification.show = !this.notification.show
                        })
                        .catch(error => {
                            if (error.response.data &&
                                error.response.data.email &&
                                error.response.data.email.includes('is invalid')) {
                                this.error = true
                            }
                            console.log(error)
                        })
                }
            }
        }
    }

</script>

<style lang="scss" scoped>

    .product-notification {
        font-weight: normal;
        font-style: italic;
        padding-bottom: 5px;

        .red-circle {
            width: 20px;
            height: 20px;
            border-radius: 100%;
            color: #fff;
            background: #dd876f;
            text-align: center;
            display: inline-block;
            font-size: 1.4rem;
            font-style: normal;
            font-weight: bold;
        }

        .error{
            color: #dd5353;
            font-size: 1.2rem;
        }

        .success{

        }

        .btn-notification, input{
            max-width: 210px;
        }

    }

</style>